import { Dispatch, SetStateAction } from "react";
import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { ProjectIndividual } from "../canonical";
import { FilterSortGroup } from "../projectTypes";
import ProjectDetailsDashWidgetFilter from "./ProjectDetailsDashWidgetFilter";
import ProjectDetailsDashWidgetSort from "./ProjectDetailsDashWidgetSort";
import ProjectDetailsDashWidgetGroup from "./ProjectDetailsDashWidgetGroup";

interface ProjectDetailsGridWidgetsProps {
  filterSortGroup: FilterSortGroup;
  setFilterSortGroup: Dispatch<SetStateAction<FilterSortGroup>>;
  hideCompletedTasks: boolean;
  setHideCompletedTasks: (value: boolean) => void;
}

function ProjectDetailsGridWidgets({
  filterSortGroup,
  setFilterSortGroup,
  hideCompletedTasks,
  setHideCompletedTasks,
}: ProjectDetailsGridWidgetsProps) {
  return (
    <>
      <Stack
        direction="row"
        width="100%"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <Typography>TASKS</Typography>
        <Stack direction="row" spacing={2} sx={{ mb: 2, alignItems: "center" }}>
          <ProjectDetailsDashWidgetFilter
            filterSortGroup={filterSortGroup}
            setFilterSortGroup={setFilterSortGroup}
          />
          <ProjectDetailsDashWidgetSort
            filterSortGroup={filterSortGroup}
            setFilterSortGroup={setFilterSortGroup}
          />
          <ProjectDetailsDashWidgetGroup
            filterSortGroup={filterSortGroup}
            setFilterSortGroup={setFilterSortGroup}
          />
          <FormControlLabel
            control={
              <Switch
                color="secondary"
                checked={hideCompletedTasks}
                onChange={(_, checked) => setHideCompletedTasks(checked)}
              />
            }
            label="Hide completed tasks"
            labelPlacement="end"
            sx={{ whiteSpace: "nowrap" }}
          />
        </Stack>
      </Stack>
    </>
  );
}

export default ProjectDetailsGridWidgets;
